import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const EntregaServicioCliente = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/06-implementacion-y-entrega-de-servicios-a-cliente.pdf`;
  /*const pdfUrl = "/pdf/06-implementacion-y-entrega-de-servicios-a-cliente.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Entrega de Servicio a Cliente</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Entrega de Servicio a Cliente" />
      </Container>
    </>
  );
};

 export default EntregaServicioCliente;
